import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchPhotoRecordByUsername({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/photos/record/fetch/username`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchPhotoRecordByUsername: ${error.message}`));
            });
        },
        FetchUserPhotoByUsername({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/photos/fetch/username`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchUserPhotoByUsername: ${error.message}`));
            });
        },
        InsertPhoto({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/photos/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => { reject(error.message); });
            });
        },
    },
}
